export default class PageSingleExpertise {
    static init() {

        if (!document.body.classList.contains('single-expertise')) {
            return;
        }

        const swiperText = document.querySelector('.swiper-single-expertise-society');
        const swiperThumbnail = document.querySelector('.swiper-single-expertise-thumbnail');
        const swiperTextNav = document.querySelector('.swiper-single-expertise-society-nav');

        if (!swiperThumbnail || !swiperText) {
            return;
        }

        const swiperThumbnailElement = new Swiper(swiperThumbnail, {
            grabCursor: true,
            spaceBetween: 20,
            slidesPerView: "auto",
        });

        const swiperTextElement = new Swiper(swiperText, {
            grabCursor: true,
            spaceBetween: 20,
            slidesPerView: "auto",
            watchOverflow: true,
            navigation: {
                prevEl: swiperTextNav.querySelector('.swiper-pill-nav-prev'),
                nextEl: swiperTextNav.querySelector('.swiper-pill-nav-next'),
            },
            on: {
                init: (swiper) => {
                    this.toggleNavigation(swiper, swiperText, swiperTextNav);
                },
                resize: (swiper) => {
                    this.toggleNavigation(swiper, swiperText, swiperTextNav);
                },
                update: (swiper) => {
                    this.toggleNavigation(swiper, swiperText, swiperTextNav);
                }
            }
        });

        swiperTextElement.controller.control = swiperThumbnailElement;
        swiperThumbnailElement.controller.control = swiperTextElement;

    }

    static toggleNavigation(swiper, container, navigation) {
        if (swiper.slides.length <= swiper.params.slidesPerView) {
            navigation.style.display = 'none';
        } else {
            navigation.style.display = 'inline-flex';
        }
    }

}
